export const hi = {
	switchTheme: 'थीम बदलें',
	next: 'आगे',
	total: 'कुल',
	stepOf: 'चरण {current} का {length}',
	industryBench: 'उद्योग बेंचमार्क',
	industryComingSoon: 'उद्योग औसत जल्द आ रहा है',
	employees: 'कर्मचारी',
	slogan: 'वैश्विक टीमों द्वारा भरोसा और पसंद किया गया',
	'estimated.time': 'अनुमानित समय',
	'changePassword.title': 'पासवर्ड बदलें',
	'auth.createAccount': 'खाता बनाएं',
	'auth.createAnAccount': 'एक खाता बनाएं',
	'auth.createYourAccount': 'अपना खाता बनाएं',
	'auth.createProfile': 'अपनी प्रोफ़ाइल बनाएं',
	'auth.signIn': 'साइन इन करें',
	'auth.signUp': 'साइन अप करें',
	'auth.login': 'लॉगिन करें',
	'auth.signInAccount': 'अपने खाते में साइन इन करें',
	'auth.acceptTerms':
		'खाता बनाना का मतलब है कि आप हमारी {terms} और {privacy} से सहमत हैं <red>*</red>',
	'auth.terms': 'सेवा की शर्तें',
	'auth.privacy': 'गोपनीयता नीति',
	'auth.dontHaveAnAccount': 'क्या आपके पास खाता नहीं है?',
	'auth.haveAccount': 'पहले से ही खाता है?',
	'auth.signUpWith': '{name} के साथ साइन अप करें',
	'auth.signInWith': '{name} के साथ साइन इन करें',
	'auth.message.quote': `परिणाम असाधारण थे और हमने उनमें से एक को काम पर रखा।
काश मैंने 500 आवेदनों को देखने से पहले ही इनके साथ शुरुआत की होती!`,
	'validation.lowercase':
		'{length, plural, =1 {एक} other {#}} छोटा {length, plural, =1 {अक्षर} other {अक्षर}}',
	'validation.uppercase':
		'{length, plural, =1 {एक} other {#}} बड़ा {length, plural, =1 {अक्षर} other {अक्षर}}',
	'validation.special':
		'{length, plural, =1 {एक} other {#}} विशेष {length, plural, =1 {अक्षर} other {अक्षर}}',
	'validation.number':
		'{length, plural, =1 {एक} other {#}} {length, plural, =1 {संख्या} other {संख्याएँ}}',
	'validation.minLength':
		'{length, plural, =0 {} =1 {कम से कम एक अक्षर} other {कम से कम # अक्षर}}',
	'validation.maxLength': '{length, number} की अधिकतम लंबाई',
	'validation.emailIncluded': 'यह ईमेल पहले से ही शामिल है',
	'auth.forgotPassword': 'पासवर्ड भूल गए?',
	'nav.organizations': 'संगठन',
	'nav.addOrg': 'नया संगठन जोड़ें',
	'nav.personalInformation': 'खाता',
	'nav.campaigns': 'अभियान',
	'nav.integrations': 'एकीकरण',
	'nav.company': 'कंपनी',
	'nav.security': 'सुरक्षा',
	'nav.billing': 'बिलिंग',
	'statusButton.nextStatus': 'अगली स्थिति:',
	'invite.challenge': 'प्रतिभा आमंत्रित करें',
	'invite.challengeLink': 'चैलेंज लिंक कॉपी करें और {type} को भेजें',
	'invite.challenge.success':
		'{name} का चैलेंज लिंक सफलतापूर्वक क्लिपबोर्ड पर कॉपी किया गया',
	'invite.challenge.uploadEmailFileDropZone': 'अपनी फ़ाइल यहाँ खींचें और छोड़ें',
	'talentGroup.menu.emailReminder': 'ईमेल अनुस्मारक भेजें',
	'talentGroup.menu.copyChallenge': 'चैलेंज कॉपी करें',
	'talentGroup.menu.deleteGroup': 'समूह हटाएं',
	'talentGroup.sendNotification':
		'नई प्रतिभाओं को चुनौती लेने के लिए आमंत्रित करने के लिए अधिसूचना ईमेल भेजें',
	'dashboard.welcome.hello': 'नमस्ते, {name}',
	'dashboard.emailVerified': 'ईमेल सत्यापित!',
	'dashboard.welcome.firstTime.welcome': 'आपके डैशबोर्ड में स्वागत है!',
	'dashboard.welcome.firstTime.createTeam': 'शुरू करने के लिए एक टीम बनाएं',
	'dashboard.welcome.createTeam': 'किसी टीम में क्लिक करें या एक नई टीम बनाएं',
	'dashboard.welcome.box.title': 'चलो शुरू करें!',
	'dashboard.welcome.box.subText':
		'प्रतिभा को नियुक्त करने या कर्मचारी कौशल की तुलना करने के लिए अपनी पहली टीम बनाएं।',
	'dashboard.welcome.box.buttonText': 'टीम बनाएं',
	'dashboard.welcome.box.trialEnded':
		'आपका निःशुल्क परीक्षण समाप्त हो गया है या आपकी योजना रद्द कर दी गई है।',
	'dashboard.welcome.firstTime.naomi.welcome': 'आपके डैशबोर्ड में स्वागत है!',
	'dashboard.welcome.firstTime.naomi.welcomeBalloon': 'स्वागत है!',
	'dashboard.welcome.firstTime.naomi.description':
		'मैं नाओमी हूँ, इस प्लेटफॉर्म का शक्तिशाली एआई इंजन। मैं आपकी टीम बनाने, कौशल मापने और समय के साथ इनसाइट्स विश्लेषण करने में आपकी मदद करूंगी।',
	'dashboard.welcome.firstTime.seeDashboard': 'मेरा डैशबोर्ड देखें!',
	'dashboard.welcome.firstTime.welcomeMessage':
		'मैं नाओमी हूँ, इस प्लेटफॉर्म का शक्तिशाली एआई इंजन। मैं आपकी टीम बनाने, कौशल मापने और समय के साथ इनसाइट्स विश्लेषण करने में आपकी मदद करूंगी।',
	'dashboard.trialExpired.title': 'आपका 14-दिन का निःशुल्क परीक्षण समाप्त हो गया है',
	'dashboard.trialExpired.desc':
		'चिंता न करें, आपके सभी डेटा तक अभी भी आपकी पहुँच है, लेकिन आपकी प्रोफ़ाइल अब सीमित क्रियाओं के साथ लॉक है। पूर्ण पहुँच प्राप्त करने के लिए एक योजना चुनें।',
	'teams.challengeDetails': 'चैलेंज विवरण देखें',
	'teams.addTalent': 'प्रतिभा आमंत्रित करें',
	'talentGroup.createNewGroup': 'नया समूह बनाएं',
	'teams.createGroup': 'समूह बनाएं',
	'teams.talentGroup': 'प्रतिभा समूह',
	'teams.attempts': 'प्रयास',
	'teams.totalTalent': 'कुल {total, plural, =1 {प्रतिभा: } other {प्रतिभाएँ: }}',
	'teams.totalGroup': 'कुल {total, plural, =1 {समूह: } other {समूह: }}',
	'teams.searchInputPlaceholder': 'प्रतिभा, प्रतिभा समूह खोजें',
	'teams.searchGroupPlaceholder': 'टीम के नाम से खोजें',
	'teams.profile.noTalentSelect': 'कोई प्रतिभा चयनित नहीं',
	'teams.profile.noTalentFound': 'कोई प्रतिभा नहीं मिली',
	'teams.profile.noTalentAdded': 'अब तक कोई प्रतिभा नहीं जोड़ी गई है',
	'teams.profile.clickOnProfile':
		'{direction} पर प्रतिभा पर क्लिक करें ताकि उनकी प्रोफ़ाइल यहाँ देख सकें!',

	'teams.talent': 'प्रतिभा',
	'teams.talent.filter.progress': 'प्रगति',
	'teams.talent.filter.createdat': 'अंतिम जोड़ा गया',
	'teams.talent.filter.updatedat': 'अंतिम अपडेट',
	'teams.talent.filter.score': 'स्कोर',
	'teams.talent.filter.name': 'नाम',
	'teams.talentGroups.filter': 'प्रदर्शन:',
	'teams.talentGroups.filter.all': 'सभी',
	'teams.talentGroups.filter.internal': 'कर्मचारी',
	'teams.talentGroups.filter.external': 'उम्मीदवार',
	'teams.talentProfile': 'प्रतिभा प्रोफ़ाइल',
	'teams.talentDynamic': 'प्रतिभा गतिशीलता',
	'teams.talentProfile.profile': 'नगेट प्रोफ़ाइल देखें',
	'teams.talentProfile.profileTooltip':
		'{name} के पास एक सार्वजनिक नगेट प्रोफ़ाइल है। इसे देखने के लिए क्लिक करें',
	'teams.talentDynamic.talent.description':
		'नीचे दिए गए प्रतिभा टैग पर क्लिक करें ताकि उसे ऊपर ग्राफ़ में पिन किया जा सके',
	'teams.talent.all': 'सभी ({total})',
	'teams.talent.employee': 'कर्मचारी ({total})',
	'teams.talent.candidate': 'उम्मीदवार ({total})',
	'jobs.notFound': 'कोई नौकरियाँ नहीं मिलीं!',
	'jobs.assignTeamMate': 'टीममेट असाइन करें',
	'jobs.assignTeamMate.placeholder': 'उपयोगकर्ता का नाम टाइप करें, फिर एंटर दबाएँ',
	'jobs.assignTeamMate.jobRole': 'नौकरी की भूमिका',
	'jobs.import': 'नौकरियाँ आयात करें',
	'jobs.noJobs':
		'आप ऊपर दाईं ओर "नई नौकरी बनाएँ" बटन पर क्लिक करके नौकरियाँ बनाना शुरू कर सकते हैं!',
	'jobs.entryLevel': 'प्रवेश स्तर - {jobType}',
	'jobs.closeDate': 'बंद करने की तिथि - {closeDate}',
	'jobs.edit': 'नौकरी संपादित करें',
	'jobs.edit.desc':
		'इस मेनू में आप नौकरी की सेटिंग्स संपादित कर सकते हैं और पुनः समीक्षा के लिए सबमिट कर सकते हैं।',
	'jobs.assign': 'असाइन करें',
	'jobs.assign.desc': 'इस नौकरी पोस्टिंग के लिए असाइन किए गए टीममेट्स का प्रबंधन करें',
	'jobs.delete': 'नौकरी हटाएँ',
	'jobs.delete.desc': 'नौकरी पोस्टिंग को हमेशा के लिए हटाएँ',
	'jobs.delete.body':
		'क्या आप वाकई <bold>{name}</bold> को हटाना चाहते हैं? इसकी सारी सामग्री स्थायी रूप से हटा दी जाएगी और इसे पुनः प्राप्त नहीं किया जा सकता।',
	'jobs.public': 'सार्वजनिक',
	'jobs.public.desc':
		'नियंत्रण करने के लिए चालू/बंद करें कि टीम में कौन नौकरी पोस्टिंग देख सकता है',
	'jobs.createdBy': '{name} द्वारा बनाई गई',
	'jobs.draft': 'ड्राफ्ट',
	'jobs.active': 'सक्रिय',
	'jobs.permission.0': 'संपादक',
	'jobs.permission.1': 'दर्शक',
	'jobs.status': 'नौकरी की स्थिति',
	'jobs.type': 'नौकरी का प्रकार',
	'jobs.creator': 'नौकरी निर्माता',
	'accountSettings.title': 'सेटिंग्स',
	'accountSettings.account': 'खाता',
	'accountSettings.billing': 'बिलिंग',
	'accountSettings.security': 'सुरक्षा',
	'accountSettings.notification': 'सूचनाएँ',
	'accountSettings.emailVerified': 'ईमेल सत्यापित',
	'accountSettings.emailNotVerified': 'ईमेल सत्यापित नहीं',
	'accountSettings.placeholder.username': 'आपका पहला नाम',
	'accountSettings.placeholder.lastname': 'आपका अंतिम नाम',
	'accountSettings.billing.title': 'उपलब्ध योजनाएँ',
	'accountSettings.billing.bothPlansCancelled.title':
		'आपकी {plan1} योजना और {plan2} रद्द कर दी गई है',
	'accountSettings.billing.bothPlansCancelled.desc':
		'आप अभी भी <bold>{date}</bold> तक {plan1} योजना और {plan2} सुविधाओं का उपयोग कर सकते हैं।',
	'accountSettings.billing.bothPlansCancelled.subdesc':
		'<bold>नोट</bold>: बिलिंग चक्र के अंत में प्रतिभा बेंचमार्किंग के लिए अंतिम भुगतान लिया जाएगा।',
	'accountSettings.billing.hiring.title': 'आपकी प्रतिभा अधिग्रहण योजना रद्द कर दी गई है',
	'accountSettings.billing.hiring.message':
		'आप अभी भी <bold>{date}</bold> तक प्रतिभा अधिग्रहण योजना की सुविधाओं का उपयोग कर सकते हैं।',
	'accountSettings.billing.benchmarking.title':
		'आपकी प्रतिभा बेंचमार्किंग योजना रद्द कर दी गई है',
	'accountSettings.billing.benchmarking.message':
		'आप अभी भी <bold>{date}</bold> तक बेंचमार्किंग योजना की सुविधाओं का उपयोग कर सकते हैं। किसी भी अतिरिक्त कर्मचारी के लिए अंतिम भुगतान पर शुल्क लिया जाएगा।',
	'accountSettings.billing.myPlans': 'मेरी योजनाएँ',
	'accountSettings.billing.nextPayment': 'आपका अगला भुगतान {date} को निर्धारित है',
	'accountSettings.billing.isCancelled': 'रद्दीकरण निर्धारित',
	'accountSettings.billing.benchmarking.no.nextPayment':
		'अंतिम भुगतान {date} को निर्धारित है।',
	'accountSettings.billing.hiring.no.nextPayment': 'सक्रिय रहेगा {date} तक।',
	'accountSettings.billing.benchmarking.note':
		'* नोट: हम केवल उन्हीं कर्मचारियों के लिए शुल्क लेते हैं जो पूरी चुनौती पूरी करते हैं। आप इसे तब देख सकते हैं जब उनकी प्रगति 100% तक पहुँच जाती है।',
	'accountSettings.billing.desc':
		'आप अपनी मौजूदा योजना के ऊपर एक अतिरिक्त योजना जोड़ सकते हैं।',
	'companySettings.drag&DropYourLogo': 'अपना लोगो यहाँ खींचें और छोड़ें',
	'companySettings.dropYourFiles': 'अपनी फ़ाइलें यहाँ छोड़ें',
	'org.placeholder.industry': 'आपकी कंपनी का उद्योग',
	'org.placeholder.companySize': 'आपकी कंपनी का आकार',
	'org.placeholder.name': 'आपकी कंपनी का नाम',
	'org.company': 'कंपनी',
	'org.companyName': 'कंपनी का नाम',
	'org.companyLogo': 'कंपनी लोगो',
	'org.yourRole': 'आपकी भूमिका',
	'org.companySize': 'कंपनी का आकार',

	'org.companyIndustry': 'कंपनी उद्योग',
	'changePassword.currentPassword': 'वर्तमान पासवर्ड',
	'changePassword.newPassword': 'नया पासवर्ड',
	'changePassword.confirmNewPassword': 'नए पासवर्ड की पुष्टि करें',
	'changePassword.passwordError': 'पासवर्ड मेल नहीं खाते',
	'changePassword.success': 'पासवर्ड सफलतापूर्वक अपडेट किया गया।',
	'addPassword.success': 'पासवर्ड सफलतापूर्वक जोड़ा गया।',
	'accountSettings.security.deleteAccount.title': 'खाता हटाएँ',
	'accountSettings.security.deleteAccount.description':
		'आप इस खाते और सभी डेटा तक पहुंच खो देंगे। इसे पूर्ववत नहीं किया जा सकता।',
	'auth.forgotPassword.0.title': 'पासवर्ड भूल गए?',
	'auth.forgotPassword.0.desc': 'अपने खाते से जुड़े ईमेल पते को दर्ज करें',
	'auth.forgotPassword.1.title': 'अपना ईमेल सत्यापित करें',
	'auth.forgotPassword.1.desc': 'कृपया {email} पर भेजा गया 4 अंकों का कोड दर्ज करें',
	'auth.forgotPassword.2.title': 'पासवर्ड रीसेट करें',
	'auth.forgotPassword.2.desc': 'कृपया अपना नया पासवर्ड जोड़ें',
	'auth.forgotPassword.success.title': 'बधाई हो!',
	'auth.forgotPassword.success.msg': 'आपका पासवर्ड सफलतापूर्वक रीसेट कर दिया गया है',
	'auth.forgotPassword.resetPassword': 'पासवर्ड रीसेट करें',
	'alert.trial.expired':
		'कोई योजना सक्रिय नहीं है। कृपया Supertalent का उपयोग जारी रखने के लिए एक योजना सक्रिय करें।',
	'alert.benchmarking.plan.canceled':
		'आपकी {plan} योजना <bold>रद्द कर दी जाएगी और {date} को अंतिम भुगतान लिया जाएगा</bold>',
	'alert.hiring.plan.canceled': 'आपकी {plan} योजना <bold>{date}</bold> को रद्द कर दी जाएगी',
	'alert.plans.canceled': 'आपकी {first} और {second} योजनाएँ {date} को रद्द कर दी जाएंगी',
	'alert.plan.failed':
		'आपकी {plan} योजना के लिए अंतिम भुगतान विफल हो गया है। कृपया सेटिंग्स > बिलिंग में ग्राहक बिलिंग पोर्टल से अपना क्रेडिट कार्ड अपडेट करें। हम अगली 2 हफ्तों में 4 बार फिर से प्रयास करेंगे, उसके बाद आपकी योजना रद्द कर दी जाएगी।',
	'alert.bothPlans.failed':
		'आपकी {benchmarking} और {hiring} योजनाओं के लिए अंतिम भुगतान विफल हो गया है। कृपया सेटिंग्स > बिलिंग में ग्राहक बिलिंग पोर्टल से अपना क्रेडिट कार्ड अपडेट करें। हम अगली 2 हफ्तों में 4 बार फिर से प्रयास करेंगे, उसके बाद आपकी योजनाएँ रद्द कर दी जाएंगी।',
	'alert.remaining.trial.days': 'आपका ट्रायल {value} दिनों में समाप्त हो रहा है',
	'alert.trial.endToday': 'आपका ट्रायल आज समाप्त हो रहा है',
	activatePlan: 'योजना सक्रिय करें',
	reactivatePlan: 'योजना फिर से सक्रिय करें',
	viewDashboard: 'डैशबोर्ड देखें',
	'header.settings': 'सेटिंग्स',
	'header.logOut': 'लॉग आउट',
	'mailVerification.verify': 'कृपया अपना ईमेल पता सत्यापित करें',
	'mailVerification.emailSent':
		'एक सत्यापन ईमेल भेजा गया है। कृपया प्रक्रिया पूरी करने के लिए अपने इनबॉक्स में दिए गए लिंक की जाँच करें।',
	'mailVerification.verified': 'आपका ईमेल सत्यापित हो गया है!',
	'mailVerification.resendButton': 'ईमेल फिर से भेजें',
	'mailVerification.resendButtonMobile': 'ईमेल सत्यापन फिर से भेजें',
	'mailVerification.resendMessage': 'ईमेल सफलतापूर्वक भेजा गया',
	'mailVerification.teams': 'टीम बनाने के लिए आपको अपना ईमेल सत्यापित करना होगा!',

	'tooltip.teamDynamic': `नीचे दिया गया स्पाइडर ग्राफ आपके टैलेंट समूहों और टैलेंट के कौशल स्तर को दर्शाता है।
	किसी टैलेंट समूह या व्यक्तिगत टैलेंट पर क्लिक करें ताकि इसे अपने ग्राफ़ में दिखा या छिपा सकें।`,
	'tooltip.talentGroup': 'टैलेंट को समूहों में विभाजित करना एक सर्वोत्तम प्रथा है।',
	'tooltip.emailReminder': 'चैलेंज पूरा करने के लिए ईमेल रिमाइंडर भेजें',
	continue: 'जारी रखें',
	pin: 'पिन करें',
	shortlist: 'शॉर्टलिस्ट करें',
	removeShortlist: 'शॉर्टलिस्ट से हटाएं',
	customFields: 'कस्टम फ़ील्ड्स',
	modifyTalent: 'समूहों को संशोधित करें',
	exportPdf: 'पीडीएफ में निर्यात करें',
	deleteTalent: 'टैलेंट हटाएं',
	delete: 'हटाएं',
	settings: 'सेटिंग्स',
	save: 'सहेजें',
	back: 'वापस',
	backTo: '{place} पर वापस जाएं',
	clear: 'साफ़ करें',
	clearAll: 'सभी साफ करें',
	welcome: 'स्वागत है',
	fieldName: 'फ़ील्ड का नाम',
	value: 'मूल्य',
	nodata: 'कोई डेटा नहीं',
	activate: 'सक्रिय करें',
	'payment.startingAt': 'शुरुआत {price} से',
	'payment.simple.pricing': 'सरल मूल्य निर्धारण',
	'payment.monthly': 'महीना',
	'payment.yearly': 'साल',

	'payment.calculate.cost.desc':
		'आपकी लागत की गणना महीने के अंत में एक क्रमिक मूल्य निर्धारण योजना के आधार पर की जाती है, जो आपके खाते में सक्रिय कर्मचारी प्रोफाइल की संख्या के अनुसार होती है।',
	'payment.calculate.cost.desc.0':
		'उदाहरण के लिए, यदि आपके पास {count} कर्मचारी प्रोफाइल हैं, तो आपको $600 की निश्चित शुल्क का भुगतान करना होगा।',
	'payment.calculate.cost.desc.1':
		'उदाहरण के लिए, यदि आपके पास {count} कर्मचारी प्रोफाइल हैं, तो आपको पहले 20 कर्मचारियों के लिए $600 की निश्चित शुल्क का भुगतान करना होगा और अगले {diff} कर्मचारियों के लिए प्रति कर्मचारी $30 का भुगतान करना होगा।',
	'payment.calculate.cost.desc.2':
		'उदाहरण के लिए, यदि आपके पास {count} कर्मचारी प्रोफाइल हैं, तो पहले 20 कर्मचारियों के लिए आपको $600, अगले 30 कर्मचारियों के लिए प्रति कर्मचारी $30 और अगले {diff} कर्मचारियों के लिए प्रति कर्मचारी $20 का भुगतान करना होगा।',
	'payment.calculate.cost': 'अनुमानित लागत की गणना करें',
	'payment.calculate.label':
		'स्लाइडर को खिसकाएं या अपने संगठन में कर्मचारियों की संख्या दर्ज करें:',
	'payment.calculate.desc':
		'मासिक मूल्य निर्धारित करने में मदद के लिए कर्मचारियों की संख्या जोड़ें',
	'payment.estimated.monthly': 'अनुमानित मासिक लागत:',
	'payment.show.pricingTable': 'मूल्य निर्धारण तालिका दिखाएं',
	'payment.hide.pricingTable': 'मूल्य निर्धारण तालिका छुपाएं',
	'payment.pricing.table.numEmployee': 'कर्मचारियों की संख्या',
	'payment.pricing.table.perEmployee': 'प्रति कर्मचारी',
	'payment.pricing.table.flatFee': 'निश्चित शुल्क',
	'payment.plan': 'योजना',
	'payment.plan.desc':
		'वह योजना चुनें जो आपकी आवश्यकताओं के अनुसार हो। दोनों की आवश्यकता है? सेटअप पूरा करने के बाद आप दूसरी योजना को उसी बिलिंग चक्र में जोड़ सकते हैं।',
	payment: 'भुगतान',
	manage: 'प्रबंधित करें',
	'payment.plan.contact':
		'अधिक आवश्यकता है? एंटरप्राइज़ समाधानों के लिए बिक्री टीम से संपर्क करें',
	'plans.freeTrial': '14 दिनों की निःशुल्क परीक्षण अवधि शुरू करें',
	'talentGroup.filters.talentGroup': 'प्रतिभा समूह',
	'talentGroup.filters.Bookmark': 'बुकमार्क',
	'talentGroup.filters.Shortlist': 'शॉर्टलिस्ट',
	'talentProfile.empty.note': 'कोई नोट नहीं मिला',
	'talentProfile.edit.note': 'नोट संपादित करें',
	'teamCard.talent': '{count, plural, =1 {प्रतिभा} other {प्रतिभाएं}}',
	'teamCardMenu.edit.primary': 'नाम बदलें',
	'teamCardMenu.mask.primary': 'प्रतिभा को गुप्त करें',
	'teamCardMenu.editattempts.primary': 'प्रयास संपादित करें',
	'teamCardMenu.editattempts.secondary': 'अपने प्रयासों को बदलें।',
	'teamCardMenu.delete.primary': 'टीम हटाएं',
	'teamCardMenu.edit.secondary': 'अपनी टीम का नाम बदलें।',
	'teamCardMenu.mask.secondary':
		'प्रतिभा को उनके व्यक्तिगत पहचान योग्य डेटा, जैसे नाम, ईमेल आदि को गुप्त करने का अवसर दें।',
	'teamCardMenu.delete.secondary': 'यह आपकी टीम को हमेशा के लिए हटा देगा।',
	'createableSelect.title': 'कोई विकल्प चुनें या नया बनाने के लिए टाइप करना शुरू करें',
	'createableSelect.editWarning': 'यह विकल्प पहले से मौजूद है',
	'createableSelect.deleteOption': 'विकल्प हटाएं',
	'createableSelect.deleteOption.body': 'क्या आप वाकई इस विकल्प को हटाना चाहते हैं?',
	'createableSelect.deleteOption.okText': 'हटाएं',
	addTalent: 'प्रतिभा को आमंत्रित करें',
	talent: 'प्रतिभा',
	'addTalent.placeholder': 'आयात करने के लिए प्रतिभा समूह चुनें',
	'addTalent.talentGroup.error.required': 'प्रतिभा समूह फ़ील्ड आवश्यक है',
	'addTalent.bulkSuccess': 'उपयोगकर्ताओं को सफलतापूर्वक बल्क में जोड़ा गया',
	'addTalent.toastSucess': 'उपयोगकर्ताओं को सफलतापूर्वक आमंत्रित किया गया',
	'addTalent.helperText':
		'जो भी ईमेल आप प्रदान करेंगे, उन पर स्वचालित रूप से एक आमंत्रण ईमेल भेजा जाएगा',
	'addTalent.uploadCount': 'अपलोड किए गए उपयोगकर्ता: {count}',
	'addTalent.remove': 'हटाएं',
	'talentGroup.createNew': 'नया प्रतिभा समूह बनाएं',
	'talentGroup.edit': 'समूह संपादित करें',
	'talentGroup.teamName.error.required': 'टीम नाम फ़ील्ड आवश्यक है',
	'talentGroup.type.error.required': 'प्रकार फ़ील्ड आवश्यक है',
	'talentGroup.color.error.required': 'टीम का रंग फ़ील्ड आवश्यक है',
	'talentGroup.helperText':
		'जो भी ईमेल आप प्रदान करेंगे, उन पर स्वचालित रूप से एक आमंत्रण ईमेल भेजा जाएगा',
	'sendEmailReminder.title': 'ईमेल रिमाइंडर भेजें',
	'sendEmailReminder.label': 'ईमेल्स',
	'sendEmailReminder.placeholder': 'अंतराल के साथ कई ईमेल दर्ज करें',
	'sendEmailReminder.helperText':
		'आप केवल उन्हीं प्रतिभाओं को ईमेल रिमाइंडर भेज सकते हैं, जो आपके प्रतिभा समूह में मौजूद हैं',
	'sendEmailReminder.checkboxLabel':
		'उन सभी को मास ईमेल रिमाइंडर भेजें जिन्होंने प्रतिभा समूह में चुनौती पूरी नहीं की है',
	'sendEmailReminder.btnLabel': 'भेजें',
	'sendEmailReminder.error.invalid': 'अमान्य ईमेल पता: {emails}',
	'sendEmailReminder.success':
		'सफलतापूर्वक {recipientCount} ईमेल {recipientCount, plural, =1 {रिमाइंडर} अन्य {रिमाइंडर्स}} भेजा गया',
	'sendEmailReminder.success.unique': 'सफलतापूर्वक ईमेल रिमाइंडर भेजा गया',
	'sendEmailReminderModal.title':
		'{masked, plural, =1 {{skeleton}} अन्य {{masked}}} को ईमेल रिमाइंडर भेजें?',
	'sendEmailReminderModal.desc':
		"'भेजें' पर क्लिक करके, {masked, plural, =1 {{skeleton}} अन्य {{masked}}} को चुनौती पूरी करने के लिए एक ईमेल रिमाइंडर भेजा जाएगा।",
	'sendEmailReminder.maskedTalent': 'गुप्त प्रतिभा',
	'editTalent.label': 'प्रतिभा समूह',
	'editTalent.desc':
		'{masked, plural, =1 {{skeleton}} अन्य {{masked}}} के लिए प्रतिभा समूह जोड़ें या हटाएं',
	'editTalent.helper':
		'प्रतिभाएं एक ही समय में कर्मचारी और उम्मीदवार समूहों में नहीं हो सकतीं',
	'challengeSubmission.title': '{value} चुनौतियाँ पूरी कर ली हैं',
	'challengeSubmission.orderedListSubmission': 'प्रतिभा द्वारा दी गई क्रमबद्ध सूची',
	'challengeDetails.desc': 'उन चुनौतियों की सूची देखें जिनका उत्तर प्रतिभाओं को देना होगा',
	'challengeSubmission.instruction':
		'इन विकल्पों को उस क्रम में व्यवस्थित करें कि आप कितनी संभावना से व्यवहार में संलग्न होंगे, सबसे ऊपर सबसे संभावित और सबसे नीचे सबसे कम संभावित रखें',
	'comment.placeholder': 'एक टिप्पणी लिखें...',
	answer: 'उत्तर',
	'challengeSubmission.prev': 'अंतरसंबंधी जागरूकता',
	'challengeSubmission.next': 'सूचना की खोज',
	totalDuration: 'अनुमानित समय:',
	challengeDetails: 'चुनौती विवरण',
	preview: 'पूर्वावलोकन',
	progress: 'प्रगति',
	mins: 'मिनट',
	spent: 'खर्च किया',
	outOf: 'में से',
	'legend.consulting': 'परामर्श',
	'legend.Series': 'श्रृंखला',
	completed: 'पूरा हुआ',
	incomplete: 'अधूरा',
	filters: 'फिल्टर',
	viewSubmission: 'प्रस्तुति देखें',
	badges: 'बैज',
	employee: 'कर्मचारी',
	candidate: 'उम्मीदवार',
	'addedAt.min':
		'{min, plural, =0 {1 मिनट पहले} =1 {1 मिनट पहले} अन्य {# मिनट पहले}} जोड़ा गया',
	'addedAt.hour': '{hour, plural, =1 {1 घंटे पहले} अन्य {# घंटे पहले}} जोड़ा गया',
	'addedAt.day': '{day, plural, =1 {1 दिन पहले} अन्य {# दिन पहले}} जोड़ा गया',
	'addedAt.date': '{date} को जोड़ा गया',
	profile: 'प्रोफ़ाइल',
	roleInterests: 'भूमिका रुचियाँ',
	selfReportedSkills: 'स्वयं रिपोर्ट की गई कौशल',
	roleFunction: 'भूमिका कार्य',
	roleLevel: 'भूमिका स्तर',
	experienceLevel: 'अनुभव स्तर',
	education: 'शिक्षा',
	softSkillScore: 'नगेट सॉफ्ट स्किल स्कोर',
	challengeSubmission: 'चुनौती प्रस्तुतिकरण',
	notes: 'टिप्पणियाँ',
	challengeProgress: 'चुनौती प्रगति',
	talentGroups: 'प्रतिभा समूह',
	sendEmailReminder: 'ईमेल रिमाइंडर भेजें',
	deleteFormName: '{masked, plural, =1 {{skeleton}} अन्य {{masked}}} हटाएं?',

	deleteFormDesc:
		'क्या आप वाकई {masked, plural, =1 {{skeleton}} अन्य {{masked}}} को हटाना चाहते हैं? इसकी सभी सामग्री स्थायी रूप से हटा दी जाएगी और पुनर्प्राप्त नहीं की जा सकती',
	editForm: '{value} संपादित करें',
	editTalentForm:
		'{masked, plural, =1 {{skeleton}} अन्य {{masked}}} के लिए समूह संशोधित करें',
	EditAttempts: 'प्रयास संपादित करें {value}',
	edit: 'संपादित करें',
	talentGroupName: 'प्रतिभा समूह का नाम',
	talentType: 'प्रतिभा प्रकार',
	updatedUser: 'खाता सफलतापूर्वक अपडेट किया गया।',
	updatedOrg: 'कंपनी सफलतापूर्वक अपडेट की गई।',
	copiedLink: 'लिंक को क्लिपबोर्ड में सफलतापूर्वक कॉपी किया गया',
	publicLink: 'सार्वजनिक लिंक',
	copyLink: 'लिंक कॉपी करें',
	link: 'लिंक',
	importVia: 'इसके माध्यम से आयात करें',
	importUser: 'उपयोगकर्ता आयात करें',
	'importUser.desc': 'नई प्रतिभा को स्वचालित रूप से चुनौती भेजी जाएगी',
	type: 'प्रकार',
	file: 'फ़ाइल',
	groupColor: 'समूह रंग',
	fileDesc:
		'नई प्रतिभा को चुनौती पूरी करने के लिए स्वचालित रूप से ईमेल भेजा जाएगा जब आप इसे आयात करेंगे',
	import: 'आयात करें',
	uploadFile: 'फ़ाइल अपलोड करें',
	loading: 'लोड हो रहा है',
	createOption: '"{value}" बनाएँ',
	warning: 'चेतावनी',
	dashboard: 'डैशबोर्ड',
	monitor: 'निगरानी करें',
	name: 'नाम',
	email: 'ईमेल',
	nuggetScore: 'नगेट स्कोर',
	score: 'स्कोर',
	account: 'खाता',
	password: 'पासवर्ड',
	firstName: 'प्रथम नाम',
	lastName: 'अंतिम नाम',
	finish: 'समाप्त करें',
	newSinceLastLogin: 'पिछली लॉगिन के बाद {count} नई प्रतिभाएँ',
	new: 'नया',
	status: 'स्थिति',
	skills: 'कौशल',
	tags: 'टैग',
	location: 'स्थान',
	or: 'या',
	challengeCopied: 'चुनौती लिंक कॉपी किया गया',
	linkedin: 'लिंक्डइन',
	emailAddress: 'ईमेल पता',
	resume: 'बायोडाटा',
	sortBy: 'इसके द्वारा क्रमबद्ध करें',
	createdAt: 'निर्माण तिथि',
	updatedAt: 'अपडेट तिथि',
	questions: 'प्रश्न',

	// Onboarding
	'onboarding.skill.with.industry.benchmark': 'उद्योग बेंचमार्क उपलब्ध है!',
	'onboarding.skill.without.industry.benchmark': 'उद्योग बेंचमार्क जल्द ही आ रहा है!',
	'onboarding.show.more.skills': 'अधिक कौशल दिखाएँ!',
	'onboarding.show.less.skills': 'कम कौशल दिखाएँ!',
	'onboarding.help.guide.header.title': 'सहायता मार्गदर्शिका',
	'onboarding.help.guide.title': 'सामान्य मार्गदर्शिका',
	'onboarding.help.guide.btn.label': 'सहायता मार्गदर्शिका',

	// Onboarding - challenge selection
	'onboarding.select.challenge.creation.title': 'चैलेंज पैक बनाने का तरीका चुनें',

	// Onboarding - challenges selection items
	'onboarding.select.role.based.challenges.title': 'भूमिका-आधारित',
	'onboarding.select.role.based.challenges.desc': 'चैलेंज पैक बनाने का तरीका चुनें',

	'onboarding.select.guided.challenges.title': 'मार्गदर्शित',
	'onboarding.select.guided.challenges.desc':
		'प्रश्नों की एक श्रृंखला का उत्तर दें और हम आपके लिए सर्वश्रेष्ठ चैलेंज सुझाएंगे',

	'onboarding.select.free.form.title': 'मुक्त-रूप',
	'onboarding.select.free.form.desc':
		'यह खुला मंच है! हमारे संपूर्ण कौशल पुस्तकालय में से चुनें',

	'onboarding.select.entry.level.title': 'कस्टम',
	'onboarding.select.entry.level.desc':
		'यह खुला मंच है! हमारे संपूर्ण कौशल पुस्तकालय में से चुनें',

	// GUIDED CHALLENGES
	// Onboarding - guided challenges steps
	'onboarding.guided.challenges.step.0': 'प्रश्न',
	'onboarding.guided.challenges.step.1': 'चैलेंज पैक पूर्वावलोकन',
	'onboarding.guided.challenges.step.2': 'टीम',

	'onboarding.guided.challenges.subStep.0': 'कंपनी के मूल्य',
	'onboarding.guided.challenges.subStep.1': 'शीर्ष प्रदर्शनकर्ता',
	'onboarding.guided.challenges.subStep.2': 'संस्कृति उपयुक्तता',
	'onboarding.guided.challenges.subStep.3': 'संस्कृति चैंपियन',

	// Onboarding - guided challenges (skill selection - root step 1)
	/* first step */
	'onboarding.guided.challenges.skillSelection.title.0':
		'अपनी कंपनी के मूल्यों और उद्देश्यों पर विचार करें और वे सॉफ्ट स्किल श्रेणियां चुनें जो आपको सबसे प्रासंगिक लगती हैं।',

	'onboarding.guided.challenges.skillSelection.description.0': 'कम से कम 3 कौशल चुनें',

	/* second step */
	'onboarding.guided.challenges.skillSelection.title.1':
		'अब, हम उन श्रेणियों के भीतर सॉफ्ट स्किल्स दिखा रहे हैं जिन्हें आपने चुना था। इनमें से कौन से सॉफ्ट स्किल्स आपको लगता है कि आपके कर्मचारियों के बेहतर प्रदर्शन के लिए सबसे ज़रूरी हैं?',

	'onboarding.guided.challenges.skillSelection.description.1': 'कम से कम 3 कौशल चुनें',

	/* third step */
	'onboarding.guided.challenges.skillSelection.title.2':
		'कभी-कभी वे कर्मचारी जो सर्वश्रेष्ठ प्रदर्शन नहीं करते, वही कंपनी के मूल्यों का प्रतिनिधित्व और समर्थन करते हैं। आपकी कंपनी में संस्कृति के चैंपियन के लिए इनमें से कौन से कौशल महत्वपूर्ण हैं?',

	'onboarding.guided.challenges.skillSelection.description.2': 'कम से कम 3 कौशल चुनें',

	/* fourth step */
	'onboarding.guided.challenges.skillSelection.title.3':
		'आइए अब शीर्ष प्रदर्शनकर्ताओं और संस्कृति चैंपियनों से थोड़ा अलग सोचें। आपकी टीम के लोग इनमें से कौन से कौशल और विकसित कर सकते हैं?',

	'onboarding.guided.challenges.skillSelection.description.3': 'कम से कम 3 कौशल चुनें',

	// Onboarding - guided challenges guides
	'onboarding.guided.challenges.help.guide.title.step.0': 'कंपनी मूल्य',
	'onboarding.guided.challenges.help.guide.desc.step.0':
		'हालांकि सभी कौशल श्रेणियां आपकी कंपनी के मूल्यों का हिस्सा हो सकती हैं, लेकिन यह निर्धारित करने के लिए प्राथमिकता दें कि कौन से वास्तव में आपकी कंपनी के सबसे महत्वपूर्ण मूल्य हैं। साथ ही, इस चैलेंज पैक को बनाने के आपके लक्ष्य पर भी विचार करें और उसी के अनुसार श्रेणियां चुनें।',

	'onboarding.guided.challenges.help.guide.title.step.1': 'शीर्ष प्रदर्शनकर्ता',
	'onboarding.guided.challenges.help.guide.desc.step.1':
		'हम चाहते हैं कि आप उन कौशलों के बारे में सोचें जो किसी कर्मचारी को आपकी कंपनी के कार्य वातावरण में उत्कृष्टता प्राप्त करने के लिए आवश्यक हैं।{linebreak}{linebreak}उदाहरण के लिए, यदि आपकी कंपनी एक तेज़-रफ्तार कार्य वातावरण को बढ़ावा देती है, तो कौन से कौशल कर्मचारियों को इस प्रकार के वातावरण में अपना सर्वश्रेष्ठ प्रदर्शन करने में सक्षम बनाएंगे?',

	'onboarding.guided.challenges.help.guide.title.step.2': 'संस्कृति अनुकूलता',
	'onboarding.guided.challenges.help.guide.desc.step.2':
		'हम चाहते हैं कि आप अपनी कंपनी के मूल्यों के बारे में सोचें और उन कौशलों की पहचान करें जो यह सुनिश्चित करने के लिए महत्वपूर्ण हैं कि कोई कर्मचारी आपकी कंपनी के मूल्यों के अनुकूल है।{linebreak}{linebreak}यदि ये वही कौशल हैं जो आपने पहले चुने थे, तो कोई समस्या नहीं है! उन सभी कौशलों को सूचीबद्ध करें जो आपकी कंपनी में फिट होने के लिए महत्वपूर्ण हैं।',

	'onboarding.guided.challenges.help.guide.title.step.3': 'संस्कृति चैंपियन',
	'onboarding.guided.challenges.help.guide.desc.step.3':
		'एक संस्कृति चैंपियन वह होता है जो आपकी कंपनी के मूल्यों को पूरी तरह अपनाता है। ये कर्मचारी जरूरी नहीं कि काम में सर्वश्रेष्ठ हों (हालांकि वे हो सकते हैं!), लेकिन वे कंपनी के मूल्यों को जीते और बढ़ावा देते हैं।{linebreak}{linebreak}वे अतिरिक्त कार्य लेते हैं ताकि वे कंपनी के मूल्यों को प्रतिबिंबित और प्रचारित कर सकें और दूसरों को भी इन मूल्यों को अपनाने के लिए प्रेरित कर सकें।',

	'onboarding.guided.challenges.help.guide.title.step.4': 'चैलेंज पैक पूर्वावलोकन',
	'onboarding.guided.challenges.help.guide.desc.step.4':
		'दिखाए गए कौशल आपकी प्रतिक्रियाओं के अनुसार "आवश्यक" और "अच्छा-होने वाला" के रूप में वर्गीकृत किए गए हैं। प्रत्येक कौशल में उन चुनौतियों की एक श्रृंखला होती है जिनका उत्तर देने वाले को उत्तर देना होगा। "चैलेंज पूर्वावलोकन" पर क्लिक करें ताकि आप एक उदाहरण देख सकें।{linebreak}{linebreak}नोट: अनुमानित समय वास्तविक डेटा पर आधारित है जो उन लोगों द्वारा उत्पन्न किया गया है जिन्होंने हमारे चैलेंज को पहले पूरा किया है।',

	'onboarding.guided.challenges.help.guide.title.step.5': 'टीम',
	'onboarding.guided.challenges.help.guide.desc.step.5':
		'यह अंतिम पृष्ठ आपको उस टैलेंट ग्रुप का नाम देने और कुछ अतिरिक्त जानकारी भरने की अनुमति देता है ताकि आप अपने चैलेंज पैक को अंतिम रूप दे सकें। आप इस पेज से प्रतिभाओं को आमंत्रित कर सकते हैं, लेकिन अभी ऐसा करना आवश्यक नहीं है। टीम बन जाने के बाद, आपको चैलेंज पैक का लिंक मिलेगा और आप इसे साझा कर सकते हैं।{linebreak}{linebreak}वे अतिरिक्त कार्य लेते हैं ताकि वे कंपनी के मूल्यों को प्रतिबिंबित और प्रचारित कर सकें और दूसरों को भी इन मूल्यों को अपनाने के लिए प्रेरित कर सकें।',

	// Onboarding - guided challenges (root step)
	/* second step */
	'onboarding.guided.challenges.step.1.title': 'कौशल समीक्षा',
	'onboarding.guided.challenges.step.1.desc':
		'आपके कौशल की सिफारिशें यहां हैं। उन्हें सबसे महत्वपूर्ण से कम महत्वपूर्ण तक व्यवस्थित करने के लिए दाईं ओर दिए गए हैंडल का उपयोग करें।',

	'onboarding.guided.challenges.step.2.title': 'टीम विवरण',

	// ROLE BASED CHALLENGES
	// Onboarding - role-based challenges steps
	'onboarding.role.based.challenges.step.0': 'भूमिका',
	'onboarding.role.based.challenges.step.1': 'चुनौतियाँ',
	'onboarding.role.based.challenges.step.2': 'चुनौती पैक पूर्वावलोकन',
	'onboarding.role.based.challenges.step.3': 'टीम',

	// Onboarding - role-based challenges (root step)
	/* first step */
	'onboarding.role.based.challenges.step.0.title': 'शुरू करने के लिए एक भूमिका चुनें',

	/* second step */
	'onboarding.role.based.challenges.step.1.title':
		'उस भूमिका के लिए चुनें जिन कौशलों को आप चुनौती पैक में शामिल करना चाहते हैं',

	'onboarding.role.based.challenges.step.1.description': 'कम से कम 3 कौशल चुनें',

	/* third step */
	'onboarding.role.based.challenges.step.2.title': 'चुनौती पैक पूर्वावलोकन',
	'onboarding.role.based.challenges.step.2.desc':
		'यह आपके बिक्री (Sales) के लिए चुनौती पैक में शामिल कौशलों का अंतिम रूप है! दाईं ओर दिए गए हैंडल (=) का उपयोग करके कौशलों को सबसे महत्वपूर्ण (शीर्ष) से कम महत्वपूर्ण (नीचे) तक क्रमबद्ध करें। आप अवांछित कौशल को लाल माइनस (-) बटन दबाकर हटा भी सकते हैं।',

	/* fourth step */
	'onboarding.role.based.challenges.step.3.title': 'टीम विवरण',

	'onboarding.role.based.challenges.help.guide.title.step.0': 'भूमिका',
	'onboarding.role.based.challenges.help.guide.desc.step.0':
		'उस भूमिका का चयन करें जो आपके परीक्षण समूह के लिए सबसे उपयुक्त हो। हम आपको उद्योग मानकों के आधार पर सबसे प्रासंगिक और महत्वपूर्ण सॉफ्ट स्किल्स के लिए एक चुनौती पैक सुझाएँगे। यदि आपकी भूमिका सूची में नहीं है, तो आप डैशबोर्ड पर वापस जाकर गाइडेड फ़ॉर्मेट का उपयोग कर सकते हैं और हमें बता सकते हैं कि कौन-सी भूमिका जोड़ी जानी चाहिए।',

	'onboarding.role.based.challenges.help.guide.title.step.1': 'चुनौतियाँ',
	'onboarding.role.based.challenges.help.guide.desc.step.1':
		'डिफ़ॉल्ट चुनौतियाँ उद्योग मानकों पर आधारित होती हैं और उस भूमिका में सफल होने के लिए आवश्यक सबसे महत्वपूर्ण सॉफ्ट स्किल्स को कवर करती हैं। ये आपकी सहायता के लिए बनाई गई हैं, लेकिन आप केवल इन्हीं तक सीमित नहीं हैं। आप चुनौतियाँ जोड़ या हटा सकते हैं। हरे संकेतक की जाँच अवश्य करें – यह दर्शाता है कि यह चुनौती उद्योग बेंचमार्क पर आधारित है, जिससे आपको यह पता चलेगा कि टेस्ट लेने वाले की स्कोरिंग उद्योग औसत की तुलना में कहाँ आती है।',

	'onboarding.role.based.challenges.help.guide.title.step.2': 'चुनौती पैक पूर्वावलोकन',
	'onboarding.role.based.challenges.help.guide.desc.step.2':
		'चुनौती पैक पूर्वावलोकन आपको आपके द्वारा चुनी गई चुनौतियों पर अंतिम नज़र डालने की अनुमति देता है। आप उनकी उपस्थिति के क्रम को समायोजित कर सकते हैं और उन चुनौतियों को हटा सकते हैं जिन्हें आप परीक्षण में शामिल नहीं करना चाहते। आप "चुनौती पूर्वावलोकन" बटन पर क्लिक करके देख सकते हैं कि उपयोगकर्ताओं को किस प्रकार का परीक्षण देना होगा।',

	'onboarding.role.based.challenges.help.guide.title.step.3': 'टीम',
	'onboarding.role.based.challenges.help.guide.desc.step.3':
		'यह अंतिम पृष्ठ आपको उस प्रतिभा समूह का नामकरण करने की अनुमति देता है जिसका आप परीक्षण कर रहे हैं और आपके चुनौती पैक के निर्माण को अंतिम रूप देने के लिए कुछ और जानकारी भरने की सुविधा देता है। आप इस पृष्ठ से चुनौती के लिए आमंत्रण भी भेज सकते हैं, लेकिन यह अभी आवश्यक नहीं है। एक बार जब टीम बन जाती है, तो आपके पास चुनौती पैक लिंक तक पहुंच होगी और आप इसे बाद में साझा कर सकते हैं।',

	'onboarding.free.form.step.0': 'चुनौतियाँ',
	'onboarding.free.form.step.1': 'चुनौती पैक पूर्वावलोकन',
	'onboarding.free.form.step.2': 'टीम',

	'onboarding.free.form.step.0.title': 'कौशल चुनें और अपना स्वयं का चुनौती पैक बनाएं',
	'onboarding.free.form.step.0.description': 'कम से कम 3 कौशल चुनें',
	'onboarding.free.form.step.1.title': 'चुनौती पूर्वावलोकन',
	'onboarding.free.form.step.1.desc':
		'यह आपके चुनौती पैक में शामिल कौशलों पर अंतिम नज़र डालने का अवसर है! दाईं ओर दिए गए हैंडल (=) का उपयोग करके कौशलों को सबसे महत्वपूर्ण (शीर्ष) से कम महत्वपूर्ण (नीचे) तक क्रमबद्ध करें। आप अनावश्यक कौशल को लाल माइनस (-) बटन दबाकर हटा भी सकते हैं।',

	'onboarding.free.form.step.2.title': 'टीम विवरण',

	'onboarding.free.form.help.guide.title.step.0': 'चुनौतियाँ',
	'onboarding.free.form.help.guide.desc.step.0':
		'डिफ़ॉल्ट चुनौतियाँ उस भूमिका में सफल होने के लिए आवश्यक सबसे महत्वपूर्ण सॉफ्ट स्किल्स के उद्योग मानकों पर आधारित होती हैं। ये आपकी सहायता के लिए बनाई गई हैं, लेकिन आप केवल इन्हीं तक सीमित नहीं हैं। आप अपनी इच्छानुसार चुनौतियाँ जोड़ या हटा सकते हैं। सुनिश्चित करें कि आप हरे संकेतक की जांच करें - यह एक उद्योग बेंचमार्क की उपस्थिति को दर्शाता है, जो आपको यह निर्धारित करने में मदद करेगा कि परीक्षार्थी का स्कोर उद्योग औसत से कैसे तुलना करता है।',

	'onboarding.free.form.help.guide.title.step.1': 'चुनौती पैक पूर्वावलोकन',
	'onboarding.free.form.help.guide.desc.step.1':
		'चुनौती पैक पूर्वावलोकन आपको उन चुनौतियों पर अंतिम नज़र डालने की अनुमति देता है, जिन्हें आपने चुना है। आप उनकी उपस्थिति के क्रम को समायोजित कर सकते हैं और उन चुनौतियों को हटा सकते हैं जिन्हें आप अब परीक्षण में शामिल नहीं करना चाहते। आप "चुनौती पूर्वावलोकन" बटन पर क्लिक करके यह भी देख सकते हैं कि उपयोगकर्ता किस प्रकार की परीक्षा देंगे।',

	'onboarding.free.form.help.guide.title.step.2': 'टीम',
	'onboarding.free.form.help.guide.desc.step.2':
		'यह अंतिम पृष्ठ आपको उस प्रतिभा समूह का नामकरण करने और कुछ और जानकारी भरने की अनुमति देता है, जिसे आप परीक्षण कर रहे हैं, ताकि आपके चुनौती पैक का निर्माण पूरा हो सके। आप इस पृष्ठ से चुनौतियों के लिए आमंत्रण भेज सकते हैं, लेकिन अभी ऐसा करना आवश्यक नहीं है - एक बार जब टीम बन जाती है, तो आपको चुनौती पैक लिंक तक पहुंच प्राप्त होगी और आप इसे साझा कर सकते हैं।',

	'onboarding.entry.level.step.0': 'मूल्यांकन विवरण',
	'onboarding.entry.level.step.1': 'प्रश्न चुनें',
	'onboarding.entry.level.step.2': 'टीम',

	'teams.onboarding.title': 'नई टीम बनाएं',
	'teams.onboarding.learnMore': 'और जानें।',

	'teams.onboarding.objective.restricted.0':
		'इस सुविधा का उपयोग करने के लिए एक भर्ती योजना आवश्यक है।',
	'teams.onboarding.objective.restricted.1':
		'इस सुविधा का उपयोग करने के लिए एक बेंचमार्किंग योजना आवश्यक है।',
	'teams.onboarding.objective.stepTitle': 'उद्देश्य',
	'teams.onboarding.objective.nyomiMessage':
		'nugget.ai सिमुलेशन-आधारित आकलनों (जिन्हें हम nugget.ai चुनौतियाँ कहते हैं) का उपयोग करता है ताकि उम्मीदवारों और कर्मचारियों की कौशल क्षमताओं को मापा जा सके। इन टूल्स का उपयोग सर्वश्रेष्ठ प्रतिभा को नियुक्त करने या अपने वर्तमान कर्मचारियों के कौशल को समझने में किया जा सकता है।',
	'teams.onboarding.objective.title': 'ध्यान केंद्रित करने के लिए एक उद्देश्य चुनें',
	'teams.onboarding.objective.description':
		'उद्देश्य यह निर्धारित करने में मदद करेगा कि आपकी कौशल सिफारिशें कैसे दी जाएंगी।',
	'teams.onboarding.objective.learnMore':
		'nugget.ai सिमुलेशन-आधारित आकलनों का उपयोग करता है, जिन्हें "चुनौतियाँ" कहा जाता है, ताकि उम्मीदवारों और कर्मचारियों की कौशल क्षमताओं को मापा जा सके। इन टूल्स का उपयोग सर्वश्रेष्ठ प्रतिभा को नियुक्त करने या अपने वर्तमान कर्मचारियों के कौशल को समझने में किया जा सकता है। \n\nआप प्रारंभ में केवल एक उद्देश्य का चयन कर सकते हैं, लेकिन एक बार आपकी टीम सक्रिय हो जाने के बाद, आप एक ही समय में भर्ती और बेंचमार्किंग के लिए समूह बना सकते हैं।',

	'teams.onboarding.objective.hiring.tooltip':
		'हम आपकी प्रतिभा पूल की कौशल क्षमता को मापने में आपकी सहायता कर सकते हैं, जिससे आपको यह जानने में मदद मिलेगी कि कौन सा उम्मीदवार किसी नौकरी के लिए सबसे उपयुक्त है, ताकि आप सर्वश्रेष्ठ उम्मीदवार को नियुक्त कर सकें।',
	'teams.onboarding.objective.benchmarking.tooltip':
		'हम आपकी कंपनी में कर्मचारियों के कौशल को मापने में भी आपकी सहायता कर सकते हैं, जिससे आप उनके मजबूत पक्षों और सुधार की आवश्यकता वाले क्षेत्रों को पहचान सकें। आप व्यक्तिगत कर्मचारियों, टीमों और पूरी कंपनी के कौशल का विश्लेषण कर सकते हैं, जिससे यह पता चलेगा कि आपकी कंपनी में लोग क्या अनोखा बनाते हैं।',

	'teams.onboarding.skillIdentification.stepTitle': 'विवरण',
	'teams.onboarding.skillIdentification.nyomiMessage.initial':
		'यह हमारे nugget.ai चैलेंज चयन प्रक्रिया की शुरुआत है! आपको <bold>कुल चार प्रश्न पूछे जाएंगे</bold> जो यह समझने में मदद करेंगे कि आपकी कंपनी में किन सॉफ्ट स्किल्स को महत्व, पुरस्कार और प्रोत्साहन दिया जाता है।',
	'teams.onboarding.skillIdentification.title.0.tooltip':
		'सॉफ्ट स्किल्स वे हस्तांतरणीय और अनुकूलन योग्य कौशल होते हैं जो एक उम्मीदवार के प्रभावी नौकरी प्रदर्शन का समर्थन करते हैं, जैसे कि संचार और समय प्रबंधन। ये हार्ड स्किल्स से अलग होते हैं, जो किसी नौकरी के लिए आवश्यक तकनीकी कौशल होते हैं।',
	'teams.onboarding.skillIdentification.description.0':
		'नीचे nugget.ai सॉफ्ट स्किल्स श्रेणियों की एक सूची दी गई है। कृपया इस पर ध्यानपूर्वक विचार करें, क्योंकि यह यह समझने के लिए महत्वपूर्ण है कि इस नौकरी के लिए एक अच्छा उम्मीदवार क्या बनाता है। अगले कुछ प्रश्नों में, आपको अधिक विशिष्ट सॉफ्ट स्किल्स चुनने का अवसर मिलेगा। कृपया सभी लागू विकल्पों का चयन करें।',
	'teams.onboarding.skillIdentification.title.1':
		'अब, हम उन श्रेणियों के भीतर की सॉफ्ट स्किल्स दिखा रहे हैं जिन्हें आपने चुना है। इनमें से कौन-सी स्किल्स इस भूमिका में उत्कृष्टता प्राप्त करने के लिए आवश्यक हैं?',
	'teams.onboarding.skillIdentification.description.1': 'सभी लागू विकल्पों का चयन करें।',
	'teams.onboarding.skillIdentification.benchmarking.nyomiMessage.succeeding':
		'आपके द्वारा पिछले प्रश्न में पहचानी गई कौशल श्रेणियों का उपयोग करते हुए, अब हम आपसे कुछ प्रश्न पूछेंगे ताकि आपकी कंपनी के लिए प्रासंगिक विशिष्ट सॉफ्ट स्किल्स का निर्धारण करने में सहायता मिल सके।',

	'teams.onboarding.skillIdentification.benchmarking.modalTitle.0': 'कंपनी मूल्य',
	'teams.onboarding.skillIdentification.benchmarking.title.0':
		'अपनी कंपनी के मूल्यों और उद्देश्यों पर विचार करें, और उन सॉफ्ट स्किल श्रेणियों का चयन करें जो आपको सबसे प्रासंगिक लगती हैं।',
	'teams.onboarding.skillIdentification.benchmarking.description.0':
		'सभी लागू विकल्पों का चयन करें।',
	'teams.onboarding.skillIdentification.benchmarking.learnMore.0':
		'यह nugget.ai चैलेंज चयन प्रक्रिया की शुरुआत है! आपको कुल चार प्रश्न पूछे जाएंगे, जो हमें यह समझने में मदद करेंगे कि आपकी कंपनी में किन सॉफ्ट स्किल्स को महत्व दिया जाता है, पुरस्कृत किया जाता है, और सुदृढ़ किया जाता है। \n\nसॉफ्ट स्किल्स वे स्थानांतरित और अनुकूलन योग्य कौशल हैं जो किसी उम्मीदवार के प्रभावी नौकरी प्रदर्शन का समर्थन करते हैं, जैसे संचार और समय प्रबंधन। ये कठिन कौशल (हार्ड स्किल्स) से भिन्न होते हैं, जो किसी नौकरी के लिए आवश्यक तकनीकी कौशल होते हैं। \n\nनीचे nugget.ai सॉफ्ट स्किल्स श्रेणियों की एक श्रृंखला दी गई है। इस पर ध्यानपूर्वक विचार करें, क्योंकि यह समझना महत्वपूर्ण है कि आपकी कंपनी को क्या अनूठा बनाता है!',

	// second step

	'teams.onboarding.skillIdentification.benchmarking.modalTitle.1': 'शीर्ष प्रदर्शनकर्ता',
	'teams.onboarding.skillIdentification.benchmarking.title.1':
		'अब, हम आपके द्वारा चुनी गई श्रेणियों के भीतर की सॉफ्ट स्किल्स दिखा रहे हैं। इन सॉफ्ट स्किल्स में से किन्हें आप अपनी कंपनी में अच्छे प्रदर्शन के लिए सबसे महत्वपूर्ण मानते हैं?',
	'teams.onboarding.skillIdentification.benchmarking.description.1':
		'सभी लागू विकल्पों का चयन करें।',
	'teams.onboarding.skillIdentification.benchmarking.learnMore.1':
		'हम चाहते हैं कि आप उन कौशलों के बारे में सोचें जो आपकी कंपनी के कार्य वातावरण में कर्मचारियों को उत्कृष्टता प्राप्त करने के लिए आवश्यक हैं।\n\nउदाहरण के लिए, यदि आपकी कंपनी एक तेज़-तर्रार कार्य वातावरण को बढ़ावा देती है, तो ऐसे कौन से कौशल हैं जो कर्मचारियों को इस प्रकार के वातावरण में सर्वोत्तम प्रदर्शन करने में सक्षम बनाएंगे?',

	// second step sub-steps

	'teams.onboarding.skillIdentification.benchmarking.sub.0': 'कंपनी के मूल्य',
	'teams.onboarding.skillIdentification.benchmarking.sub.1': 'शीर्ष प्रदर्शनकर्ता',
	'teams.onboarding.skillIdentification.benchmarking.sub.2': 'संस्कृति चैंपियन',
	'teams.onboarding.skillIdentification.benchmarking.sub.3': 'कौशल अंतराल',

	// third step

	'teams.onboarding.skillIdentification.benchmarking.modalTitle.2': 'संस्कृति चैंपियन',
	'teams.onboarding.skillIdentification.benchmarking.title.2':
		'कई बार वे कर्मचारी जो सर्वश्रेष्ठ प्रदर्शनकर्ता नहीं होते, वे भी कंपनी के मूल्यों का प्रतिनिधित्व और समर्थन करते हैं। आपकी कंपनी में संस्कृति चैंपियन के लिए कौन-कौन से कौशल महत्वपूर्ण हैं?',
	'teams.onboarding.skillIdentification.benchmarking.description.2':
		'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.benchmarking.learnMore.2': `संस्कृति चैंपियन वह व्यक्ति होता है जो आपकी कंपनी के मूल्यों को आत्मसात करता है। ये कर्मचारी कार्यस्थल पर सर्वश्रेष्ठ प्रदर्शनकर्ता नहीं भी हो सकते हैं (हालांकि हो सकते हैं!), लेकिन वे कंपनी के मूल्यों को जीते और बढ़ावा देते हैं।
            \nवे कंपनी के मूल्यों को प्रतिबिंबित और प्रचारित करने का प्रयास करते हैं और दूसरों को भी इन्हें अपनाने के लिए प्रेरित करते हैं।`,

	// fourth step

	'teams.onboarding.skillIdentification.benchmarking.modalTitle.3': 'कौशल अंतराल',
	'teams.onboarding.skillIdentification.benchmarking.title.3':
		'आइए अब शीर्ष प्रदर्शनकर्ताओं और संस्कृति चैंपियनों से थोड़ा अलग दृष्टिकोण अपनाते हैं। आपकी टीम के लोग इनमें से किन कौशलों को और विकसित कर सकते हैं?',
	'teams.onboarding.skillIdentification.benchmarking.description.3':
		'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.benchmarking.learnMore.3':
		'अब तक हमने उन कौशलों को कवर किया है जो आपकी कंपनी के शीर्ष प्रदर्शनकर्ताओं और संस्कृति चैंपियनों के लिए आवश्यक हैं। अब उन कौशलों की पहचान करें, जिनमें आपकी टीम के सदस्य सुधार और विकास कर सकते हैं।',

	'teams.onboarding.skillIdentification.benchmarking.title.1.tooltip':
		'हम चाहते हैं कि आप उन कौशलों के बारे में सोचें जो किसी कर्मचारी को आपकी कंपनी के कार्य परिवेश में उत्कृष्ट प्रदर्शन करने के लिए आवश्यक हैं।{linebreak}{linebreak}उदाहरण के लिए, यदि आपकी कंपनी एक तेज़-रफ्तार कार्य वातावरण को बढ़ावा देती है, तो ऐसे कौन से कौशल हैं जो कर्मचारियों को इसमें सर्वश्रेष्ठ प्रदर्शन करने में मदद कर सकते हैं?',
	'teams.onboarding.skillIdentification.benchmarking.title.2.tooltip':
		'हम चाहते हैं कि आप अपनी कंपनी के मूल्यों के बारे में सोचें और उन कौशलों की पहचान करें जो किसी कर्मचारी के लिए आपकी कंपनी के मूल्यों से मेल खाने के लिए महत्वपूर्ण होंगे।',
	'teams.onboarding.skillIdentification.benchmarking.title.3.tooltip':
		'एक संस्कृति चैंपियन वह व्यक्ति होता है जो आपकी कंपनी के मूल्यों को पूरी तरह आत्मसात करता है। ये कर्मचारी कार्य में शीर्ष प्रदर्शनकर्ता न भी हों (हालांकि वे हो सकते हैं!), लेकिन वे कंपनी के मूल्यों को जीते और बढ़ावा देते हैं।{linebreak}{linebreak}वे कंपनी के मूल्यों को प्रतिबिंबित और प्रचारित करने का प्रयास करते हैं और दूसरों को भी इन्हें अपनाने के लिए प्रेरित करते हैं।',

	// team onboarding - skill identification - /benchmarking

	// team onboarding - skill identification - hiring/

	'teams.onboarding.skillIdentification.hiring.nyomiMessage.succeeding':
		'पिछले प्रश्न में पहचानी गई कौशल श्रेणियों का उपयोग करते हुए, अब हम आपसे कुछ प्रश्न पूछेंगे ताकि हम उन विशिष्ट सॉफ्ट स्किल्स का निर्धारण कर सकें जो आप जिस पद के लिए भर्ती कर रहे हैं, उसके लिए प्रासंगिक हैं।',

	// first step
	'teams.onboarding.skillIdentification.hiring.modalTitle.0': 'उम्मीदवार के सॉफ्ट स्किल्स',
	'teams.onboarding.skillIdentification.hiring.title.0':
		'इनमें से किन सॉफ्ट स्किल्स श्रेणियों की आप अपने आदर्श उम्मीदवार में तलाश कर रहे हैं?',
	'teams.onboarding.skillIdentification.hiring.description.0': 'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.hiring.learnMore.0':
		'यह हमारे nugget.ai चैलेंज चयन प्रक्रिया की शुरुआत है! आपको कुल चार प्रश्न पूछे जाएंगे, जो हमें इस भूमिका के लिए आवश्यक सॉफ्ट स्किल्स की जानकारी देंगे।\n\nसॉफ्ट स्किल्स वे स्थानांतरित और अनुकूलनीय कौशल होते हैं जो उम्मीदवार की प्रभावी नौकरी प्रदर्शन में सहायता करते हैं, जैसे संचार और समय प्रबंधन। ये हार्ड स्किल्स से भिन्न होते हैं, जो नौकरी के लिए आवश्यक तकनीकी कौशल होते हैं।',

	// second step
	'teams.onboarding.skillIdentification.hiring.modalTitle.1': 'आवश्यक कौशल',
	'teams.onboarding.skillIdentification.hiring.title.1':
		'अब, हम आपको उन श्रेणियों के अंतर्गत आने वाले सॉफ्ट स्किल्स दिखा रहे हैं जिन्हें आपने चुना था। इन कौशलों में से कौन से इस भूमिका में उत्कृष्टता प्राप्त करने के लिए आवश्यक हैं?',
	'teams.onboarding.skillIdentification.hiring.description.1': 'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.hiring.learnMore.1':
		'पिछले प्रश्न में आपने जिन कौशल श्रेणियों की पहचान की थी, उनके आधार पर अब हम आपसे ऐसे विशिष्ट सॉफ्ट स्किल्स से जुड़े प्रश्न पूछेंगे जो आपकी भर्ती की जा रही नौकरी के लिए प्रासंगिक हैं।\n\nहम चाहते हैं कि आप उन कौशलों के बारे में सोचें जो किसी कर्मचारी के लिए इस नौकरी में उत्कृष्ट प्रदर्शन करने के लिए आवश्यक हैं।\n\nये वे कौशल हैं जो आप चाहते हैं कि किसी कर्मचारी के पास पहले दिन से ही हों ताकि वह इस भूमिका को सफलतापूर्वक निभा सके।',

	// second step sub-steps
	'teams.onboarding.skillIdentification.hiring.sub.0': 'उम्मीदवार के सॉफ्ट स्किल्स',
	'teams.onboarding.skillIdentification.hiring.sub.1': 'आवश्यक कौशल',
	'teams.onboarding.skillIdentification.hiring.sub.2': 'प्रशिक्षण योग्य कौशल',
	'teams.onboarding.skillIdentification.hiring.sub.3': 'कंपनी के अनुकूलता',

	// third step
	'teams.onboarding.skillIdentification.hiring.modalTitle.2': 'प्रशिक्षण योग्य कौशल',
	'teams.onboarding.skillIdentification.hiring.title.2':
		'इन कौशलों में से कौन से अच्छे तो हैं, लेकिन इस भूमिका के लिए आवश्यक नहीं हैं, या ऐसे कौशल हैं जिन्हें नौकरी के दौरान प्रशिक्षित किया जा सकता है?',
	'teams.onboarding.skillIdentification.hiring.description.2': 'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.hiring.learnMore.2':
		'सभी ऐसे कौशल चुनें जिन्हें या तो नौकरी के दौरान प्रशिक्षित किया जा सकता है, या जिनके लिए आप अतिरिक्त प्रशिक्षण प्रदान करने या सुझाने के लिए तैयार हैं।',

	// fourth step
	'teams.onboarding.skillIdentification.hiring.modalTitle.3': 'कंपनी के अनुकूलता',
	'teams.onboarding.skillIdentification.hiring.title.3':
		'हमने उन कौशलों को कवर कर लिया है जो उस भूमिका के लिए विशिष्ट हैं, जिसके लिए आप भर्ती कर रहे हैं। अब आपकी कंपनी को व्यापक रूप से सोचते हैं। इन कौशलों में से कौन से आपकी कंपनी के मूल्यों और संस्कृति के कारण आपके आदर्श उम्मीदवार के लिए महत्वपूर्ण होंगे?',
	'teams.onboarding.skillIdentification.hiring.description.3': 'सभी उपयुक्त विकल्प चुनें।',
	'teams.onboarding.skillIdentification.hiring.learnMore.3':
		'भूमिका के लिए आवश्यक कौशलों से परे, ये वे कौशल हैं जिन्हें आपकी कंपनी में आम तौर पर महत्व दिया जाता है।\n\nयदि ये कौशल पहले चुने गए कौशलों से मिलते-जुलते हैं, तो यह कोई समस्या नहीं है! कृपया उन कौशलों को हाइलाइट करें जो आपकी कंपनी में फिट होने के लिए महत्वपूर्ण हैं।',

	'teams.onboarding.skillIdentification.hiring.title.1.tooltip':
		'हम चाहते हैं कि आप उन कौशलों के बारे में सोचें जो किसी कर्मचारी के लिए इस नौकरी में उत्कृष्ट प्रदर्शन करने के लिए आवश्यक हैं।{linebreak}{linebreak}ये वे कौशल हैं जो आप चाहते हैं कि किसी कर्मचारी के पास पहले दिन से ही हों ताकि वह इस भूमिका को सफलतापूर्वक निभा सके।',
	'teams.onboarding.skillIdentification.hiring.title.2.tooltip':
		'ये वे कौशल हैं जिन्हें या तो नौकरी के दौरान प्रशिक्षित किया जा सकता है, या जिनके लिए आप अतिरिक्त प्रशिक्षण प्रदान करने या सुझाने के लिए तैयार हैं।',
	'teams.onboarding.skillIdentification.hiring.title.3.tooltip':
		'ये वे कौशल हैं जिनका कर्मचारी अपनी नौकरी के दौरान लगातार उपयोग करेगा, इसलिए नए कर्मचारी की भर्ती करते समय इन पर विचार करना बहुत महत्वपूर्ण है।{linebreak}{linebreak}उदाहरण के लिए, यदि भूमिका में किसी को अनिश्चितता के माहौल में लगातार काम करना पड़ता है, तो एक ऐसा कौशल जिसे वह हर दिन उपयोग करेगा, वह होगा "अस्पष्टता के प्रति सहनशीलता"।',

	'teams.onboarding.skillImportance.stepTitle': 'कौशल',
	'teams.onboarding.skillImportance.nyomiMessage':
		'इन सभी सवालों के जवाब देने के लिए धन्यवाद! हमने पिछले चरण में पहचाने गए सभी सॉफ्ट स्किल्स को उनकी महत्त्वपूर्णता के आधार पर क्रमबद्ध किया है। हमने "आवश्यक" और "अच्छा होगा" श्रेणियों में कौशलों को वर्गीकृत किया है, जो इस चैलेंज में उपयोग किए जाएंगे।',
	'teams.onboarding.skillImportance.title': 'कौशल समीक्षा',
	'teams.onboarding.skillImportance.modalTitle': 'कौशल समीक्षा',
	'teams.onboarding.skillImportance.learnMore':
		'जो कौशल प्रस्तुत किए गए हैं, वे आपके द्वारा दिए गए उत्तरों के परिणामस्वरूप हैं। हमारा सिस्टम आपकी ज़रूरत के अनुसार सर्वोत्तम फिट कौशलों को क्यूरेट करने के लिए प्रशिक्षित है। जब हम कौशल की सिफारिश करते हैं, तो हम उन्हें "आवश्यक" और "अच्छा होगा" सॉफ्ट स्किल्स में वर्गीकृत करते हैं। प्रत्येक कौशल एक चैलेंज होता है, जिसका प्रतिभाओं को उत्तर देना होगा।\n\nनोट: अनुमानित समय एक मीट्रिक है जिसे साइंस टीम ने वास्तविक लोगों के साथ किए गए प्रत्यक्ष प्रयोगों के आधार पर प्रदान किया है। प्रत्येक चैलेंज का कुल समय सीमा अलग होती है, जो अनुमानित समय से भिन्न हो सकती है। हम अधिकतम 3-5 चैलेंज चुनने की सिफारिश करते हैं, ताकि प्रतिभाओं के लिए उत्तर देना आसान हो।',
	'teams.onboarding.skillImportance.description':
		'आपकी कौशल सिफारिशें यहाँ हैं। उन्हें पुनः क्रमबद्ध करने के लिए दाईं ओर दिए गए हैंडल का उपयोग करें, ताकि सबसे अधिक से कम महत्वपूर्ण कौशलों को प्रतिबिंबित किया जा सके।',
	'teams.onboarding.skillImportance.totalChallengeTime.title': 'अनुमानित कुल समय:',
	'teams.onboarding.skillImportance.skillsRequired':
		'कम से कम {count} कौशल आवश्यक हैं। वापस जाएं और अपनी प्राथमिकताएँ संपादित करें।',
	'teams.onboarding.skillImportance.totalChallengeTime.title.tooltip':
		'सभी प्रासंगिक कौशलों को ध्यान में रखते हुए, हमने अनुमानित समय नोट किया है, जो उम्मीदवार को पूरा चैलेंज समाप्त करने में लगेगा यदि आप प्रत्येक कौशल का मूल्यांकन करते हैं।',
	'teams.onboarding.skillImportance.totalChallengeTime.description':
		'प्रत्येक कौशल अनुभाग के साथ एक समय जुड़ा होता है, जो यह दर्शाता है कि कर्मचारियों को इसे पूरा करने में कितना समय लगेगा।',
	'teams.onboarding.skillImportance.mustHaveSkills.title': 'अनिवार्य कौशल',
	'teams.onboarding.skillImportance.mustHaveSkills.description':
		'वो जो काम पूरा करने के लिए बिल्कुल जरूरी हैं।',
	'teams.onboarding.skillImportance.niceToHaveSkills.title': 'अच्छा होगा अगर ये कौशल हों',
	'teams.onboarding.skillImportance.niceToHaveSkills.description':
		'ये वे कौशल हैं जो आप चाहते हैं कि आपके कर्मचारी के पास हों, लेकिन वे आवश्यक नहीं हैं।',

	'teams.onboarding.teamDetails.stepTitle': 'टीम',
	'teams.onboarding.teamDetails.nyomiMessage':
		'आपकी चुनौती बनाई जा चुकी है! अब अपनी टीम बनाएं और मैं चुनौती भेज दूंगी।',
	'teams.onboarding.teamDetails.title': 'टीम विवरण',
	'teams.onboarding.teamDetails.description':
		'कृपया अपनी कंपनी के कर्मचारियों की जानकारी नीचे भरें।',
	'teams.onboarding.teamDetails.teamName': 'टीम का नाम',
	'teams.onboarding.teamDetails.maskChallenge': 'चुनौती को छुपाएं',
	'teams.onboarding.teamDetails.maskChallenge.description':
		'यदि आप "हाँ" चुनते हैं, तो चुनौती लेने वाले किसी भी व्यक्ति को अपने प्रोफाइल को गुमनाम बनाने का विकल्प मिलेगा, जिससे नाम और ईमेल जैसी व्यक्तिगत पहचान योग्य जानकारी छिपाई जा सकेगी।',
	'teams.onboarding.teamDetails.maskChallenge.tooltip':
		'यह सुनिश्चित करने में मदद कर सकता है कि लोग चुनौती का उत्तर देने में सहज महसूस करें। शोध से पता चला है कि इससे आपकी चुनौती पूर्ण करने की दर 50% तक बढ़ सकती है।',
	'teams.onboarding.teamDetails.talentGroupDetails': 'प्रतिभा समूह विवरण',
	'teams.onboarding.teamDetails.talentGroupDetails.description':
		'आप इस टीम के अंदर इस उम्मीदवार समूह की पहचान करने के लिए एक समूह बना सकते हैं।',
	'teams.onboarding.teamDetails.talentGroupDetails.talentType.tooltip':
		'प्रतिभा प्रकार का उपयोग कर्मचारियों और उम्मीदवारों के बीच अंतर करने के लिए किया जाता है।',
	'teams.onboarding.teamDetails.talentGroupDetails.talentColor': 'प्रतिभा का रंग',
	'teams.onboarding.teamDetails.talentGroupDetails.inviteTeammates':
		'प्रतिभा को आमंत्रित करें',
	'teams.onboarding.teamDetails.talentGroupDetails.inviteTeammates.description':
		'उन्हें चुनौती लिंक भेजने के लिए ईमेल दर्ज करें। आप इसे दोबारा भेज सकते हैं या बाद में भेज सकते हैं।',

	all: 'सभी',
	faq: 'सामान्य प्रश्न',
	yes: 'हाँ',
	no: 'नहीं',
	multiEmailFieldPlaceholder:
		'एक ईमेल टाइप करें और भेजने या दूसरा जोड़ने के लिए एंटर दबाएं',
	browseFiles: 'फाइलें ब्राउज़ करें',
	fileFormat: 'फाइल प्रारूप',
	maximumSize: 'अधिकतम आकार',

	'tour.title': 'एक दौरा करें!',
	'tour.naomi': 'हाय, मैं नाओमी हूँ, आपकी एआई सहायक, यहाँ {linebreak} आपकी मदद के लिए!',
	'tour.description': 'नेविगेट करने में सहायता चाहिए? हमारे सहायता गाइड का अन्वेषण करें।',
	'tour.seeVideoDemo': 'वीडियो डेमो देखें',
	'tour.viewDemoData': 'डेमो डेटा',
	'tour.learnAboutOurScience': 'हमारा विज्ञान',
	'tour.closingMessage':
		'चिंता न करें, आप अभी भी शीर्ष नेविगेशन पैन से गाइड लिंक प्राप्त कर सकते हैं।',

	'tours.team.addTalent': 'प्रतिभा आमंत्रित करें',
	'tours.team.addTalent.desc':
		'प्रतिभा जोड़ने के लिए यहां क्लिक करें। आप एक CSV फ़ाइल आयात कर सकते हैं या ऑफ़लाइन भेजने के लिए एक लिंक उत्पन्न कर सकते हैं।',
	'tours.team.groupCard': 'प्रतिभा समूह कार्ड',
	'tours.team.groupCard.desc':
		'अपनी प्रतिभा को समूहों में व्यवस्थित करें। हमने आपके लिए पहला समूह बना दिया है।',
	'tours.team.addTalentGroup': 'प्रतिभा समूह जोड़ें',
	'tours.team.addTalentGroup.desc': 'नया प्रतिभा समूह बनाने के लिए यहां क्लिक करें।',
	'tours.team.talent': 'प्रतिभा',
	'tours.team.talent.desc':
		'कोई भी प्रतिभा जिसे आप आयात करते हैं या अपनी टीम लिंक से आमंत्रित करते हैं, यहां दिखाई देगी।',
	'tours.team.talentDynamic': 'प्रतिभा डायनामिक्स',
	'tours.team.talentDynamic.desc':
		'एक बार जब प्रतिभा चुनौतियों को पूरा कर लेती है, तो आप उनकी कौशल को देख सकेंगे और दूसरों के साथ तुलना कर सकेंगे।',
	'tours.team.finish': 'समाप्त करें',
	'Welcome back, John!': 'वापसी पर स्वागत है, जॉन!',
	'No applicants found for today': 'आज के लिए कोई आवेदक नहीं मिला',
	'Recent Assessment': 'हालिया मूल्यांकन',
	'Time Taken': 'लिया गया समय',
	'Exam Taken On': 'दी गई परीक्षा',
	Today: 'आज',
	'Last 7 Days': 'पिछले ७ दिन',
	'Last 30 Days': 'पिछले ३० दिन',
	Team: 'टीम',
	Group: 'समूह',
	'All Attempts': 'सभी प्रयास',
	Live: 'सक्रिय',
	Finished: 'समाप्त',
	Terminated: 'समाप्त किया गया',
	'Here s Asseessment Overview': 'यहाँ मूल्यांकन का अवलोकन है',
	'Section Name': 'अनुभाग का नाम',
	'Add New Section': 'नया सेक्शन जोड़ें',
	'No of Questions': 'प्रश्नों की संख्या',
	'Sub-Section Name': 'उप-अनुभाग का नाम',
	'Add New SubSection': 'नया उप-सेक्शन जोड़ें',
	'Question Type': 'प्रश्नों का प्रकार',
	'Question Name': 'प्रश्नों का नाम',
	'Subsection Name': 'उप अनुभाग का नाम',
	Question: 'प्रश्न',
	'Upload Question': 'प्रश्न अपलोड करें',
	'Single Question': 'एकल प्रश्',
	'Bulk Upload': 'समूह अपलोड',
	Answers: 'उत्तर',
	'Correct Answers': 'सही उत्तर',
	Marks: 'अंक',
	Explanation: 'व्याख्या',
	Add: 'जोड़ें',
	Cancel: 'रद्द करें',
	Create: 'बनाएँ',
	Description: 'विवरण',
	'Allowed file formats: .csv, .xlsx': 'अनुमत फ़ाइल प्रारूप: .csv, .xlsx',
	'Headers Format': 'हैडर प्रारूप',
	Tooltip: 'क्रम संख्या | प्रश्न प्रकार | प्रश्न | उत्तर 1 | उत्तर 2 | उत्तर 3 | उत्तर 4 ',
	Tooltips:
		'सही उत्तर | उत्तरों की संख्या | व्याख्या | अंक | उत्तर विकल्प | ऋणात्मक अंक (%)',
	Submit: '	जमा करें'
}
